import z, { useState as B, useEffect as S, useReducer as j, useRef as N, useCallback as v, isValidElement as X, cloneElement as J } from "react";
import q from "../../react-from-dom/dist/index.js";
var K = Object.defineProperty, Q = (e, t, n) => t in e ? K(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, b = (e, t, n) => Q(e, typeof t != "symbol" ? t + "" : t, n), V = "react-inlinesvg", W = 10, r = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  FAILED: "failed",
  READY: "ready",
  UNSUPPORTED: "unsupported"
};
function Z(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function R() {
  var e;
  return !!(typeof window < "u" && ((e = window.document) != null && e.createElement));
}
function ee() {
  return re() && typeof window < "u" && window !== null;
}
function te(e, ...t) {
  const n = {};
  for (const s in e)
    ({}).hasOwnProperty.call(e, s) && (t.includes(s) || (n[s] = e[s]));
  return n;
}
function ne(e) {
  const t = "abcdefghijklmnopqrstuvwxyz", s = `${t}${t.toUpperCase()}1234567890`;
  let a = "";
  for (let f = 0; f < e; f++)
    a += Z(s);
  return a;
}
async function $(e, t) {
  const n = await fetch(e, t), s = n.headers.get("content-type"), [a] = (s ?? "").split(/ ?; ?/);
  if (n.status > 299)
    throw new Error("Not found");
  if (!["image/svg+xml", "text/plain"].some((f) => a.includes(f)))
    throw new Error(`Content type isn't valid: ${a}`);
  return n.text();
}
function se(e = 1) {
  return new Promise((t) => {
    setTimeout(t, e * 1e3);
  });
}
function re() {
  if (!document)
    return !1;
  const e = document.createElement("div");
  e.innerHTML = "<svg />";
  const t = e.firstChild;
  return !!t && t.namespaceURI === "http://www.w3.org/2000/svg";
}
var ce = class {
  constructor() {
    b(this, "cacheApi"), b(this, "cacheStore"), b(this, "subscribers", []), b(this, "isReady", !1), this.cacheStore = /* @__PURE__ */ new Map();
    let e = V, t = !1;
    R() && (e = window.REACT_INLINESVG_CACHE_NAME ?? V, t = !!window.REACT_INLINESVG_PERSISTENT_CACHE && "caches" in window), t ? caches.open(e).then((n) => {
      this.cacheApi = n;
    }).catch((n) => {
      console.error(`Failed to open cache: ${n.message}`), this.cacheApi = void 0;
    }).finally(() => {
      this.isReady = !0;
      const n = [...this.subscribers];
      this.subscribers.length = 0, n.forEach((s) => {
        try {
          s();
        } catch (a) {
          console.error(`Error in CacheStore subscriber callback: ${a.message}`);
        }
      });
    }) : this.isReady = !0;
  }
  onReady(e) {
    this.isReady ? e() : this.subscribers.push(e);
  }
  async get(e, t) {
    var n;
    return await (this.cacheApi ? this.fetchAndAddToPersistentCache(e, t) : this.fetchAndAddToInternalCache(e, t)), ((n = this.cacheStore.get(e)) == null ? void 0 : n.content) ?? "";
  }
  set(e, t) {
    this.cacheStore.set(e, t);
  }
  isCached(e) {
    var t;
    return ((t = this.cacheStore.get(e)) == null ? void 0 : t.status) === r.LOADED;
  }
  async fetchAndAddToInternalCache(e, t) {
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === r.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: r.IDLE }), await this.fetchAndAddToInternalCache(e, t);
      });
      return;
    }
    if (!(n != null && n.content)) {
      this.cacheStore.set(e, { content: "", status: r.LOADING });
      try {
        const s = await $(e, t);
        this.cacheStore.set(e, { content: s, status: r.LOADED });
      } catch (s) {
        throw this.cacheStore.set(e, { content: "", status: r.FAILED }), s;
      }
    }
  }
  async fetchAndAddToPersistentCache(e, t) {
    var a, f, E;
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === r.LOADED)
      return;
    if ((n == null ? void 0 : n.status) === r.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: r.IDLE }), await this.fetchAndAddToPersistentCache(e, t);
      });
      return;
    }
    this.cacheStore.set(e, { content: "", status: r.LOADING });
    const s = await ((a = this.cacheApi) == null ? void 0 : a.match(e));
    if (s) {
      const u = await s.text();
      this.cacheStore.set(e, { content: u, status: r.LOADED });
      return;
    }
    try {
      await ((f = this.cacheApi) == null ? void 0 : f.add(new Request(e, t)));
      const u = await ((E = this.cacheApi) == null ? void 0 : E.match(e)), d = await (u == null ? void 0 : u.text()) ?? "";
      this.cacheStore.set(e, { content: d, status: r.LOADED });
    } catch (u) {
      throw this.cacheStore.set(e, { content: "", status: r.FAILED }), u;
    }
  }
  async handleLoading(e, t) {
    var n;
    for (let s = 0; s < W; s++) {
      if (((n = this.cacheStore.get(e)) == null ? void 0 : n.status) !== r.LOADING)
        return;
      await se(0.1);
    }
    await t();
  }
  keys() {
    return [...this.cacheStore.keys()];
  }
  data() {
    return [...this.cacheStore.entries()].map(([e, t]) => ({ [e]: t }));
  }
  async delete(e) {
    this.cacheApi && await this.cacheApi.delete(e), this.cacheStore.delete(e);
  }
  async clear() {
    if (this.cacheApi) {
      const e = await this.cacheApi.keys();
      await Promise.allSettled(e.map((t) => this.cacheApi.delete(t)));
    }
    this.cacheStore.clear();
  }
};
function k(e) {
  const t = N(void 0);
  return S(() => {
    t.current = e;
  }), t.current;
}
function ie(e) {
  const {
    baseURL: t,
    content: n,
    description: s,
    handleError: a,
    hash: f,
    preProcessor: E,
    title: u,
    uniquifyIDs: d = !1
  } = e;
  try {
    const c = ae(n, E), A = q(c, { nodeOnly: !0 });
    if (!A || !(A instanceof SVGSVGElement))
      throw new Error("Could not convert the src to a DOM Node");
    const l = H(A, { baseURL: t, hash: f, uniquifyIDs: d });
    if (s) {
      const i = l.querySelector("desc");
      i != null && i.parentNode && i.parentNode.removeChild(i);
      const h = document.createElementNS("http://www.w3.org/2000/svg", "desc");
      h.innerHTML = s, l.prepend(h);
    }
    if (typeof u < "u") {
      const i = l.querySelector("title");
      if (i != null && i.parentNode && i.parentNode.removeChild(i), u) {
        const h = document.createElementNS("http://www.w3.org/2000/svg", "title");
        h.innerHTML = u, l.prepend(h);
      }
    }
    return l;
  } catch (c) {
    return a(c);
  }
}
function ae(e, t) {
  return t ? t(e) : e;
}
function H(e, t) {
  const { baseURL: n = "", hash: s, uniquifyIDs: a } = t, f = ["id", "href", "xlink:href", "xlink:role", "xlink:arcrole"], E = ["href", "xlink:href"], u = (d, c) => E.includes(d) && (c ? !c.includes("#") : !1);
  return a && [...e.children].forEach((d) => {
    var c;
    if ((c = d.attributes) != null && c.length) {
      const A = Object.values(d.attributes).map((l) => {
        const i = l, h = /url\((.*?)\)/.exec(l.value);
        return h != null && h[1] && (i.value = l.value.replace(h[0], `url(${n}${h[1]}__${s})`)), i;
      });
      f.forEach((l) => {
        const i = A.find((h) => h.name === l);
        i && !u(l, i.value) && (i.value = `${i.value}__${s}`);
      });
    }
    return d.children.length ? H(d, t) : d;
  }), e;
}
var g;
function oe(e) {
  const {
    cacheRequests: t = !0,
    children: n = null,
    description: s,
    fetchOptions: a,
    innerRef: f,
    loader: E = null,
    onError: u,
    onLoad: d,
    src: c,
    title: A,
    uniqueHash: l
  } = e, [i, h] = j(
    (o, w) => ({
      ...o,
      ...w
    }),
    {
      content: "",
      element: null,
      isCached: t && g.isCached(e.src),
      status: r.IDLE
    }
  ), { content: P, element: _, isCached: G, status: D } = i, p = k(e), L = k(i), F = N(l ?? ne(8)), C = N(!1), x = N(!1), m = v(
    (o) => {
      C.current && (h({
        status: o.message === "Browser does not support SVG" ? r.UNSUPPORTED : r.FAILED
      }), u == null || u(o));
    },
    [u]
  ), I = v((o, w = !1) => {
    C.current && h({
      content: o,
      isCached: w,
      status: r.LOADED
    });
  }, []), U = v(async () => {
    const o = await $(c, a);
    I(o);
  }, [a, I, c]), y = v(() => {
    try {
      const o = ie({ ...e, handleError: m, hash: F.current, content: P }), w = q(o);
      if (!w || !X(w))
        throw new Error("Could not convert the src to a React element");
      h({
        element: w,
        status: r.READY
      });
    } catch (o) {
      m(o);
    }
  }, [P, m, e]), M = v(async () => {
    const o = /^data:image\/svg[^,]*?(;base64)?,(.*)/u.exec(c);
    let w;
    if (o ? w = o[1] ? window.atob(o[2]) : decodeURIComponent(o[2]) : c.includes("<svg") && (w = c), w) {
      I(w);
      return;
    }
    try {
      if (t) {
        const T = await g.get(c, a);
        I(T, !0);
      } else
        await U();
    } catch (T) {
      m(T);
    }
  }, [t, U, a, m, I, c]), O = v(async () => {
    C.current && h({
      content: "",
      element: null,
      isCached: !1,
      status: r.LOADING
    });
  }, []);
  S(
    () => {
      if (C.current = !0, !(!R() || x.current)) {
        try {
          if (D === r.IDLE) {
            if (!ee())
              throw new Error("Browser does not support SVG");
            if (!c)
              throw new Error("Missing src");
            O();
          }
        } catch (o) {
          m(o);
        }
        return x.current = !0, () => {
          C.current = !1;
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), S(() => {
    if (!(!R() || !p) && p.src !== c) {
      if (!c) {
        m(new Error("Missing src"));
        return;
      }
      O();
    }
  }, [m, O, p, c]), S(() => {
    D === r.LOADED && y();
  }, [D, y]), S(() => {
    !R() || !p || p.src !== c || (p.title !== A || p.description !== s) && y();
  }, [s, y, p, c, A]), S(() => {
    if (L)
      switch (D) {
        case r.LOADING: {
          L.status !== r.LOADING && M();
          break;
        }
        case r.LOADED: {
          L.status !== r.LOADED && y();
          break;
        }
        case r.READY: {
          L.status !== r.READY && (d == null || d(c, G));
          break;
        }
      }
  }, [M, y, G, d, L, c, D]);
  const Y = te(
    e,
    "baseURL",
    "cacheRequests",
    "children",
    "description",
    "fetchOptions",
    "innerRef",
    "loader",
    "onError",
    "onLoad",
    "preProcessor",
    "src",
    "title",
    "uniqueHash",
    "uniquifyIDs"
  );
  return R() ? _ ? J(_, {
    ref: f,
    ...Y
  }) : [r.UNSUPPORTED, r.FAILED].includes(D) ? n : E : E;
}
function de(e) {
  g || (g = new ce());
  const { loader: t } = e, [n, s] = B(g.isReady);
  return S(() => {
    n || g.onReady(() => {
      s(!0);
    });
  }, [n]), n ? /* @__PURE__ */ z.createElement(oe, { ...e }) : t;
}
export {
  g as cacheStore,
  de as default
};
//# sourceMappingURL=index.js.map
